<template>
  <div
    class="bg-primary-base w-32 h-6 fixed z-[1000] text-white flex items-center justify-center rotate-[315deg] origin-top-left top-0 left-0 mt-16 -ml-6 transform shadow"
  >
    <span class="font-medium text-sm">PREVIEW</span>
  </div>
</template>
